import { heart } from '../assets/heart'
import { moon } from '../assets/moon'
import { energy } from '../assets/energy'
import { IconPoint } from '../types/homepage'

export const biometricSignals: IconPoint[] = [
  {
    icon: heart,
    title: 'Heart-rate patterns',
    description:
      'We’re exploring how changes in heart rate could add context to conversations about stress and wellbeing.',
  },
  {
    icon: moon,
    title: 'Sleep and rest',
    description:
      'Sleep patterns may help you and your therapist discuss rest, routines, and how you’re feeling.',
  },
  {
    icon: energy,
    title: 'Activity and energy',
    description:
      'Activity information could help put everyday routines and changes in energy into context.',
  },
]
